import React, {useEffect, useState} from 'react';

import RPMStreamChat from './rpmStreamChat';
import RoundedContainer from './roundedContainer';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { StreamChat } from 'stream-chat';
import moment from 'moment';
import Button from "@material-ui/core/Button"
import CTAButton from './ctaButton';




const MainChat = ({...props}) =>
  {
    const [tabValue, setValue] = useState(0);
    const [chatClient, setChatClient] = useState(null);
    const [primaryChannel, setPrimaryChannel] = useState(null);
    const [secondaryChannel, setSecondaryChannel] = useState(null);
    const [primaryUnread, setPrimaryUnread] = useState(0);
    const [secondaryUnread, setSecondaryUnread] = useState(0);

    const handleChange = (event, newValue) => {    
      setValue(newValue);     
    };

    useEffect(()  => {
      setChatClient(newChatClient(props.attendee));     
    },[])

    useEffect(() => {
      if(chatClient) 
      {
        //Create New Chat Channel
        const unique = props.currentRoom.unique_chat !== '' ? props.currentRoom.unique_chat : props.currentRoom.unique;
        setPrimaryChannel(
          newChatChannel(chatClient, 
            `session_${unique}`, //Channel
            `${props.currentRoom.title} ${moment(props.currentRoom.start).format("HH:mm mm/dd/yy")}` //Channel Name
          )
        );
      }
    },[chatClient, props.currentRoom])

    useEffect(() => {
      if(primaryChannel) 
      {      
        primaryChannel.watch();      
        chatClient.on('message.new', chatHandlerNew);    
        if(!props.currentRoom.q_a && !props.currentRoom.hide_secondary_chat)
       {
          const unique = props.currentRoom.unique_chat !== '' ? props.currentRoom.unique_chat : props.currentRoom.unique;
          setSecondaryChannel(newChatChannel(chatClient, `secondary_${unique}_${props.attendee.location.replace(/[^A-Z0-9]+/ig, "_")}`, `${props.currentRoom.title} ${moment(props.currentRoom.start).format("HH:mm mm/dd/yy")}`));
        }
        
        return () => {                 
          setPrimaryUnread(0);
          chatClient.off('message.new',chatHandlerNew);
          primaryChannel.stopWatching();          
        }
      }
    },[primaryChannel])

    

    const chatHandlerNew = (event) => {   
      if(props.currentRoom.q_a && event.user.id == chatClient.user.id && event.channel_id == primaryChannel.id && event.message.type == 'regular')
      {
        primaryChannel.sendReaction(event.message.id, {
          type: "like"
        }) 
      }     
      
      if(props.currentRoom.q_a && event.user.id == chatClient.user.id && event.channel_id == primaryChannel.id && event.message.type == 'reply' && props.attendee.chat_moderator)
      {
        chatClient.getMessage(event.message.parent_id).then((parentMessage) => {          
          const newMessage = parentMessage.message.text.indexOf('✅') == -1 ? `✅ ${parentMessage.message.text}` : `${parentMessage.message.text}`
          chatClient.updateMessage({id: parentMessage.message.id, text: newMessage});
        });
        
      }

    }
    
    useEffect(() => {
      if(secondaryChannel) 
      {
        secondaryChannel.watch();        


        return () => {                        
            
            secondaryChannel.stopWatching();
        }
      }
    
    },[secondaryChannel])

    
    const a11yProps = (index) => {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }

    const newChatChannel = (chatClient, channel, channelName) => {
    return chatClient.channel('livestream', channel, {      
      name: channelName ? channelName : channel
    });
    }

    const newChatClient = (user) => {    
    const chatClient = new StreamChat(user.chat_key, null, '111876') 
    const userToken = user.chat_token;
    const userName = user.chat_moderator ? `RPM Moderator` : `${user.first_name} ${user.last_name}`;


    chatClient.setUser(
      {
          id: user.id,          
          name: userName ,
          image: user.avatar
      },
      userToken,
    ); 

    return chatClient;
    }

    const toggleFreeze = (status) => {
      const user = props.attendee;
      const userName = user.chat_moderator ? `RPM Moderator` : `${user.first_name} ${user.last_name}`;
      const currentChannel = tabValue == 0 ? primaryChannel : secondaryChannel;
      currentChannel.update(
        { frozen: status }, 
        { text: status ? `${userName} has frozen the channel.` : `${userName} has unfrozen the channel.`, user_id: user.id });
  }

  
   
    return (
      <>
      {props.attendee.chat_moderator && (
      <RoundedContainer className="flex flex-row space-x-8 items-center justify-center bg-red-500">
          <CTAButton
            text="Freeze Channel"
            toggled={false}
            onButtonClick={() => {
              toggleFreeze(true)
            }}
          />    
          <CTAButton
            text="Unfreeze Channel"
            toggled={true}
            onButtonClick={() => {
              toggleFreeze(false)
            }}
          />    
        </RoundedContainer> )}
      <RoundedContainer className="main-chat relative flex-wrap h-full" xPadding="0" yPadding="0">
       
        <Tabs value={tabValue} onChange={handleChange} aria-label="chat tabs" className="flex-initial w-full max-h-tiny">
          <Tab label={props.currentRoom.room_type.value == 'breakout' ? `Q & A` : props.mainChatLabel} {...a11yProps(0)} />
          {(!props.currentRoom.q_a && !props.currentRoom.hide_secondary_chat) &&(            
          <Tab label={`${props.attendee.location} Chat`} {...a11yProps(1)} />                        
          )}
        </Tabs>
        
        <div hidden={tabValue !== 0} id={`chat-panel-0`} className="flex-auto w-full overflow-hidden relative min-h-lg max-h-lg">
          {(tabValue === 0 && chatClient !== null && primaryChannel != null) && (
            <RPMStreamChat chatClient={chatClient} chatChannel={primaryChannel} />
          )}
        </div>
        
        <div hidden={tabValue !== 1} id={`chat-panel-0`} className="flex-auto w-full overflow-hidden relative min-h-lg max-h-lg">
          {(tabValue === 1 && chatClient !== null && secondaryChannel != null) && (
             <RPMStreamChat  chatClient={chatClient} chatChannel={secondaryChannel} />
          )}
        </div>        
        
      </RoundedContainer>
         
      
      
      </>
    )
  }



export default MainChat;